import { render, staticRenderFns } from "./FundSubmitted.vue?vue&type=template&id=05c16510&"
import script from "./FundSubmitted.vue?vue&type=script&lang=js&"
export * from "./FundSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports